import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { selectCoop, selectCoopShowNotification } from "../../../selectors/selectCoopInfo";
import { actionCoopMenuSetFirstTab, actionCoopMenuTabGoTo, TypeActionCoopInfo } from "../actionCoop";
import { IdCoopCategory } from "../IdCoopCategory";
export var epicCoopHudButtonClicked = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.CoopHudClicked), switchMap(function () {
        var state = state$.value;
        var coop = selectCoop(state);
        var unreadChatMessages = state.chatInfo.unreadMessages > 0;
        if (!coop) {
            return from([
                actionCoopMenuSetFirstTab(IdCoopCategory.CoopFound),
                actionCoopMenuTabGoTo(IdCoopCategory.CoopSearch),
            ]);
        }
        var hasLoyaltyPointsNotification = selectCoopShowNotification(state);
        var actions = [actionCoopMenuSetFirstTab(IdCoopCategory.CoopInfoView)];
        if (hasLoyaltyPointsNotification) {
            actions.push(actionCoopMenuTabGoTo(IdCoopCategory.CoopHelp));
        }
        else if (unreadChatMessages) {
            actions.push(actionCoopMenuTabGoTo(IdCoopCategory.CoopChat));
        }
        else {
            actions.push(actionCoopMenuTabGoTo(IdCoopCategory.CoopInfoView));
        }
        return from(actions);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopHudButtonClicked.ts
// module id = 1803
// module chunks = 3